import Cookies from 'js-cookie';
export function parseLoginState(cookieName) {
    const cookieData = Cookies.get(cookieName);
    if (cookieData) {
        try {
            const value = JSON.parse(cookieData);
            if (typeof value === `object` && value !== null) {
                if (typeof value.uid === `string` &&
                    (value.customerType === `private` ||
                        value.customerType === `commercial`)) {
                    return {
                        status: `logged-in`,
                        uid: value.uid,
                        customerType: value.customerType,
                    };
                }
                else if (value.status === `login-error`) {
                    return { status: `login-error` };
                }
            }
        }
        catch { }
    }
    return { status: `logged-out` };
}
//# sourceMappingURL=parse-login-state.js.map